
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class StockAllocateGrid extends _Ext.GridBase<Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StockItemService.baseUrl; }
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery, options) {
            super(container, options);
            var attributeId = options.GridFilters.AttributeId;
            var productId = options.GridFilters.ProductId;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            (this.view.params as TransactionRequest).AttributeId = attributeId;
            (this.view.params as TransactionRequest).ProductId = productId;
            (this.view.params as TransactionRequest).StockAllocation = false;
            return this;
        }

        get selectedItems(): Stock.StockItemRow[] {
            var _this = this;
            var x = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            return x;
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        }; 
        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            return true;
        }
    }
}